export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M14 20.5h-4a2 2 0 1 0 4 0m4-9c0-3.07-1.64-5.64-4.5-6.32V4.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.86 6 8.42 6 11.5v5l-2 2v1h16v-1l-2-2z\"/>"
};